<div class="container-fluid p-3 overflow-auto">
    <div class="row mb-3">
        <h2>Pre-signup Information</h2>
    </div>
    <div class="row mb-3">
        <mat-radio-group aria-label="Are you a business or individual?" [(ngModel)]="isIndividual">
            <mat-radio-button [value]="true">Individual</mat-radio-button>
            <mat-radio-button [value]="false">Business</mat-radio-button>
        </mat-radio-group>
    </div>
    <form class="mb-3" [formGroup]="businessDetailsForm" *ngIf="isIndividual === false">
        <div class="row" formGroupName="businessDetails">
            <div class="col-6">
                <mat-form-field class="w-100">
                    <input matInput required name="businessName" id="businessName" placeholder="Business Name" type="text"
                        formControlName="businessName" />
                    <mat-error *ngIf="businessDetailsForm.get('businessDetails.businessName').errors?.required">Business Name is
                        required
                    </mat-error>
                    <mat-error *ngIf="businessDetailsForm.get('businessDetails.businessName').errors?.validationErrors">
                        {{ businessDetailsForm.get('businessDetails.businessName').errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field class="w-100">
                    <input matInput required name="website" id="website" placeholder="https://example.com" type="text"
                        formControlName="website" />
                    <mat-error *ngIf="businessDetailsForm.get('businessDetails.website').errors?.required">Website Url is required
                    </mat-error>
                    <mat-error *ngIf="businessDetailsForm.get('businessDetails.website').errors?.validationErrors">
                        {{ businessDetailsForm.get('businessDetails.website').errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-2">
            <button mat-raised-button class="w-100" (click)="onClose()">Submit</button>
        </div>
        <div class="col-2">
            <button mat-raised-button class="w-100 warning" (click)="dialogRef.close()" *ngIf="!disableClose">Close</button>
        </div>
    </div>
</div>